module.exports = __webpack_public_path__ + "img/about-companyFr.42ee02cb.png";